import { Col, Container, Row } from "react-bootstrap"
import { Disc, Discord, Instagram, Palette} from "react-bootstrap-icons"
import { Link } from "react-router-dom"

const Footer =() => {
    return(
        <Container fluid className="bg-offblack py-3 text-primary footer">
            <Container className="py-5">
                <ul className="d-flex justify-content-center fs-1 gap-6 list-unstyled">
                    <a className="text-center text-decoration-none">
                        <li><a href="https://discordapp.com/users/1018918217265188904"><Discord /></a></li>
                        <h6>Discord</h6>
                    </a>
                    <a className="text-center text-decoration-none">
                        <li><a href="https://www.instagram.com/_riddle_vrasl/"><Instagram /></a></li>
                        <h6>Instagram</h6>
                    </a>
                    <a className="text-center text-decoration-none" href="https://www.artstation.com/riddle-squared">
                        <li><a href="https://www.instagram.com/_riddle_vrasl/"><Palette /></a></li>
                        <h6>ArtStation</h6>
                    </a>
                </ul>
            </Container>
        </Container>
    )
}

export default Footer